import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { reloadForNewDeploy } from "@/lib/stale-deploy";
import { reachTeams, rememberTeamsHost } from "@/lib/teams";
import { App } from "./app";
import "./app.css";

// Vite's preload helper reports a chunk that failed to load here. After a
// deploy that means this tab runs the old build, so load the new one.
window.addEventListener("vite:preloadError", (event) => {
  if (reloadForNewDeploy()) event.preventDefault();
});

// Before routing, which drops the tab URL's ?host=teams on its first redirect.
// Teams waits for the tab to initialize the SDK; outside Teams it never loads.
rememberTeamsHost();
void reachTeams();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Root element "#root" is missing from index.html');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
